export default __webpack_public_path__ + "static/media/news-head.aaef13b0.png";